var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_vm._v(" ©2014-2022 中能魔力（河南）网络科技有限公司版权所有 豫ICP备14100822号-1 豫公网安备 44030602004264号文本 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }